export const DASHBOARD_DATA_TYPE_ENUM = {
  PERCENTAGE: 'percentage',
  VALUE: 'value'
}

export default DASHBOARD_DATA_TYPE_ENUM
